import {Alert} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {MoreSitesPage} from 'src/jobs/order-plus/more-sites-page'
import {orderLabel} from 'src/jobs/order-plus/order-label'
import {OrderPageFrame} from 'src/jobs/order-plus/order-page-frame'
import {validateOrderPlusSearch} from 'src/jobs/order-plus/order-plus-search'

export const Route = createFileRoute('/_app/projects/$projectId/more-sites')({
    validateSearch: validateOrderPlusSearch,
    component: MoreSitesRoute,
})

function MoreSitesRoute() {
    const {projectId} = Route.useParams()
    const {from} = Route.useSearch()
    return (
        <OrderPageFrame
            projectId={projectId}
            title={(order) => `More sites for order ${orderLabel(order)}`}
            description="The same job at several sites, one job per site"
        >
            {(order, {canEdit}) =>
                from ? (
                    <MoreSitesPage
                        projectId={projectId}
                        orderLabel={orderLabel(order)}
                        sourceJobId={from}
                        readOnly={!canEdit}
                    />
                ) : (
                    <Alert color="yellow">Open + More sites from a job of this order.</Alert>
                )
            }
        </OrderPageFrame>
    )
}
